export default __webpack_public_path__ + "static/media/space-x-mockup.cebccd30.png";